import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'

/**
 * Base
 */

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Loaders
 */
// GLTF loader
const gltfLoader = new GLTFLoader()

/**
 * Sound
 */

// Thanks to CarlosCAV at freesound.org for cricket sound

 const listener = new THREE.AudioListener()
 const sound = new THREE.Audio( listener )
 const audioLoader = new THREE.AudioLoader()
 
 // Sound button
 const startButton = document.getElementById( 'playButton' )
 startButton.addEventListener( 'click', function () {
 
     audioLoader.load( '543965__carloscav__cricket-grillo.ogg', function( buffer ) {
     sound.setBuffer( buffer )
     sound.setLoop( true )
    //  sound.setVolume( 0.5 )
     if (!sound.isPlaying) {
         sound.play()
     } else {
         sound.pause()
     }
     })
 
 } )
 
let mixer = null

// put toggle button here?

gltfLoader.load('cricket.glb',
    (gltf) =>
        {
            let cricket = gltf.scene
            cricket.rotation.y = - Math.PI * 0.5
            scene.add(cricket)
            console.log(gltf.animations)

            mixer = new THREE.AnimationMixer(cricket)
            const clip01 = THREE.AnimationClip.findByName( gltf.animations, 'rightWingAction')
            const clip02 = THREE.AnimationClip.findByName( gltf.animations, 'leftWingAction')
            const clip03 = THREE.AnimationClip.findByName( gltf.animations, 'rightAntennaAction')
            const clip04 = THREE.AnimationClip.findByName( gltf.animations, 'leftAntennaAction')
            const rightWing = mixer.clipAction(clip01)
            const leftWing = mixer.clipAction(clip02)
            const rightAntenna = mixer.clipAction(clip03)
            const leftAntenna = mixer.clipAction(clip04)
            leftWing.play()
            rightWing.play()
            leftAntenna.play()
            rightAntenna.play()

            cricket.traverse((child) =>
            {
                if(child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial)
                {
                    child.castShadow = true
                    child.receiveShadow = true
                }
            })
        }
)

let mixer02 = null

gltfLoader.load('cricket02.glb',
    (gltf) =>
        {
            let cricket02 = gltf.scene
            cricket02.rotation.y = Math.PI * 0.9
            cricket02.position.x = 2
            cricket02.position.z = -3
            scene.add(cricket02)
            console.log(gltf.animations)

            mixer02 = new THREE.AnimationMixer(cricket02)
            const clip01 = THREE.AnimationClip.findByName( gltf.animations, 'rightWingAction')
            const clip02 = THREE.AnimationClip.findByName( gltf.animations, 'leftWingAction')
            const clip03 = THREE.AnimationClip.findByName( gltf.animations, 'rightAntennaAction')
            const clip04 = THREE.AnimationClip.findByName( gltf.animations, 'leftAntennaAction')
            const rightWing = mixer02.clipAction(clip01)
            const leftWing = mixer02.clipAction(clip02)
            const rightAntenna = mixer02.clipAction(clip03)
            const leftAntenna = mixer02.clipAction(clip04)
            leftWing.play()
            rightWing.play()
            leftAntenna.play()
            rightAntenna.play()

            cricket02.traverse((child) =>
            {
                if(child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial)
                {
                    child.castShadow = true
                    child.receiveShadow = true
                }
            })
        }
)

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(60, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 5
camera.position.y = 2   
camera.position.z = 6

/**
 * Lights
 */
const ambientLight = new THREE.AmbientLight(0xffffff, 0.1)
scene.add(ambientLight)

const directionalLight = new THREE.DirectionalLight(0xffffff, 1)
directionalLight.castShadow = true
directionalLight.shadow.normalBias = 0.05
directionalLight.position.set(-5, 5, 5)
scene.add(directionalLight)

const directionalLight2 = new THREE.DirectionalLight(0xffffff, 0.5)
directionalLight2.castShadow = true
directionalLight2.shadow.normalBias = 0.05
directionalLight2.position.set(5, -5, -2)
scene.add(directionalLight2)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true
})
renderer.outputEncoding = THREE.sRGBEncoding
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap
renderer.setClearColor( 0xbbbbff )

/**
 * Animate
 */
const clock = new THREE.Clock()
let prevTime = Date.now()
let prevTime02 = Date.now()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    // Update mixers

    if ( mixer ) {
        const time = Date.now()
        mixer.update( ( time - prevTime ) * 0.001 )
        prevTime = time
    }

    if ( mixer02 ) {
        const time02 = Date.now()
        mixer02.update( ( time02 - prevTime02 ) * 0.001 + 0.001 )
        prevTime02 = time02
    }

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()